import ApiOptions from '@/datatypes/api-options';

export default class ApiPutOptions extends ApiOptions {
  constructor(options) {
    super(options);

    this.method = 'put';
  }
}
